
import {defineComponent, PropType} from "vue";
import VideoContainer from "../../components/VideoContainer.vue";
import {PushZigZagDto} from "../../../showcase/models/OfferApiResponse";

export default defineComponent({
    name: "EditorialPush",
    components: {
        VideoContainer
    },
    props: {
        zigzag: {
            type: Object as PropType<PushZigZagDto>,
            required: true
        },
        additionalClasses: {
            type: String,
            default: ""
        },
        withImageResize: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        definePictureLayout(index: number) {
            const oddClass = this.zigzag?.firstIsEven ? "ob1-push-zigzag-even ob1-push-md-shadow-left" : "ob1-push-zigzag-odd"
            const evenClass = this.zigzag?.firstIsEven ? "ob1-push-zigzag-odd" : "ob1-push-zigzag-even ob1-push-md-shadow-left"
            const startIndex = this.zigzag?.firstIsEven ? 0 : 1
            const computedIndex = index + startIndex
            const isEven = computedIndex % 2 === 0
            return isEven ? evenClass : oddClass
        }
    }
});
